





















































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BviPlot extends Vue {

    height = 200;
    ymax: (number|null) = null;
    ymin: (number|null) = null;
    fixed = 0;

    @Prop() readonly data: any;

    mounted() {
        this.ymax = this.data.total.reduce((a: number,v: number)=>Math.max(a,v));

        if(this.ymax) {
            if(this.ymax > 100) {
                //round to the next nearest 50
                this.ymax = Math.floor(this.ymax / 100) * 100 + 100;
            } else {
                //if max is less than 50, then use that instead
            }
        }
        this.ymin = 0;
    }

    lineCommand = (point: number, i: number) => `L ${this.itox(i)} ${this.ptoy(point)}`

    ptoy(p: number) {
        if(this.ymin == null) return;
        if(this.ymax == null) return;

        const per = (p - this.ymin)/(this.ymax - this.ymin);
        return (this.height-40) - (this.height - 50)*per;
    }

    itox(y: number) {
        return ((1000-200)/(this.data.total.length-1))*y+150;
    }

    t2x(date: string) {
        const d = new Date(date);
        const begin = new Date("2012-01-01").getTime();
        const end = new Date("2020-01-01").getTime();
        const duration = end - begin;
        const x = ((1000-150)/duration)*(d.getTime()-begin)+100;
        return x;
    }

    a2h(amount: number) {
        return amount/100000+1;
    }

    fillPath(points: number[], command: any) {
        let d = "";

        //top
        for(let i = 0;i < points.length; ++i) {
            if(i == 0) d += 'M '+this.itox(i)+','+this.ptoy(points[i]);
            else d+= command(points[i], i);
        } 
        //bottom
        for(let i = points.length-1;i >= 0; --i) {
            d+= command(0, i);
        } 
        return d;
    }

    linePath(points: number[], command: any) {
        const d = points.reduce((acc: string, point: number, i: number)=>{
            if(i === 0) return `M ${this.itox(i)},${this.ptoy(point)}`
            else return `${acc} ${command(point, i)}`
        }, '')
        return d;
    }

    get yticks() {
        if(this.ymin == null) return [];
        if(this.ymax == null) return [];

        const ticks: number[] = [];

        //compute optimal min/max step
        const range = this.ymax - this.ymin;
        const step = range/2.5;
        const min = Math.round(this.ymin/step)*step;
        const max = this.ymax;
        for(let p = min;p <= max;p+=step) {
            const y = this.ptoy(p);
            if(y !== undefined && y > this.height-30) continue;
            ticks.push(p);
        }
        return ticks;
    }
}
